import PropTypes from 'prop-types';
import React from 'react'

import { Row, Col, FormGroup, Label, Switch } from 'twyne-new.ui';

class TcpaQuestionForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tcpaquestion: null,
      customFields: null,
      customFieldSelected: null,
    }
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
    this.updateOptions(this.state.customFieldSelected);
  }

  updateCustomFields = ({ integrationData: { extraFields, tcpaquestion } }) => {
    const customFields = (extraFields || []).map(({
      id, group, type, options, date_format, key: value, name: label,
    }) => ({
      id, group, type, options, date_format, value, label: `${label} (${type})`,
    }));
    const customFieldSelected = customFields.find(field => tcpaquestion.cfid === field.value) || {};
    tcpaquestion.cfid_number = tcpaquestion.cfid_number || customFieldSelected.id;

    this.state = {
      tcpaquestion,
      customFields,
      customFieldSelected,
    };
  }
  makeDefaultAnswer = answer => ({
    key: "",
    answer: "",
    fontcolor: "255,255,255,1",
    color: "113,113,113,1", ...answer,
  })

  addPostData = (answers, answer) => {
    answers.push(this.makeDefaultAnswer(answer));
    return answers
  }

  updateOptions = cf => {
    const { tcpaquestion } = this.state
    if (!cf) return;
    const isSelect = cf.type === 'select';
    const isBoolean = cf.type === 'boolean';

    if (isBoolean || isSelect) {
      if (isSelect) {
        const { answers } = tcpaquestion;
        const currentKeyAnswers = answers.map(({ key }) => key);
        const newKeysAnswers = cf.options.map(({ value: key }) => key);
        answers.forEach((answer, idx) => {
          !newKeysAnswers.includes(answer.key) && this.handleClickRemovePostData(idx);
        });
        cf.options.forEach(({ value: key, label: answer }) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData({ key, answer });
        });
      }
      if (isBoolean) {
        const { answers } = tcpaquestion;
        const options = [{ key: "true", answer: "Yes" }, { key: "false", answer: "No" }];
        const currentKeyAnswers = answers.map(({ key }) => key);
        answers.forEach(({ key }, idx) => {
          !["true", "false"].includes(key) && this.handleClickRemovePostData(idx)
        });
        options.forEach(({ key, answer }, idx) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData(this.makeDefaultAnswer({ key, answer }))
        });
        return;
      }
      return;
    }
    tcpaquestion.answers = tcpaquestion.answers || [];
  }

  handleClickRemovePostData = idx => {
    const { answers } = this.state.tcpaquestion
    answers.splice(idx, 1);
    this.props.onChange('answers', answers)
  }

  handleClickAddPostData = answer => {
    this.props.onChange('answers', this.addPostData(this.state.tcpaquestion.answers, answer))
  }

  handleEnableTrustedForm = e => {
    const { checked } = e.target

    if (checked) {
      if (this.state.tcpaquestion.cfid === null || this.state.tcpaquestion.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.tcpaquestion.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }
  }

  handleEnableLeadId = e => {
    const { checked } = e.target

    if (checked) {
      if (this.state.tcpaquestion.cfid === null || this.state.tcpaquestion.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.tcpaquestion.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }
  }
  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }

  render() {
    return (
      <div key={this.state.tcpaquestion.cfid || ''}>
        <Row className='mt-4'>
          {this.props.settings}
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={e => this.handleEnableTrustedForm(e)}
                checked={this.state.tcpaquestion.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={e => this.handleEnableLeadId(e)}
                checked={this.state.tcpaquestion.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.tcpaquestion.alwaysShow || false}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.tcpaquestion.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Save Consent Text</Label>
              <Switch
                onChange={this.handleEnable('saveConsentText')}
                checked={this.state.tcpaquestion.saveConsentText || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}
TcpaQuestionForm.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func,
}
export default TcpaQuestionForm;
